import React, { useState, useEffect } from 'react';
import axios from "axios";

export default function ByRequestOfInfo({ requestors }) {
    const [billDraftByRequestOfs, setBillDraftByRequestOfs] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    async function fetchNonStandingCommitteeData(nonStandingCommitteeId, legislatureId) {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_LAWS_BACKEND_HOST}/committees/v1/nonStandingCommittees/search?limit=10&offset=0`,
                {
                    nonStandingCommitteeIds: [nonStandingCommitteeId],
                    legislatureIds: [legislatureId]
                },
                {
                    headers: {
                        'accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error fetching committee data: ", error);
            throw error;
        }
    }

    async function fetchStandingCommitteeData(StandingCommitteeId, legislatureId) {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_LAWS_BACKEND_HOST}/committees/v1/standingCommittees/search?limit=10&offset=0`,
                {
                    standingCommitteeIds: [StandingCommitteeId],
                    legislatureIds: [legislatureId]
                },
                {
                    headers: {
                        'accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error fetching committee data: ", error);
            throw error;
        }
    }

    async function fetchAgencyData(requestorId) {
        try {
            const response = await axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/organizations/${requestorId}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching bill draft agency data: ", error);
        }
    }

    async function fetchBillDraftByRequestOf(requesters) {
        const byRequestOfDataArray = await Promise.all(
            requesters.map(async (requester) => {
                let byRequestOfData;
                switch (requester.billRequestType) {
                    case "ORGANIZATION":
                        byRequestOfData = await fetchAgencyData(requester.byRequestOfId);
                        break;
                    case "NON_STANDING_COMMITTEE":
                        byRequestOfData = await fetchNonStandingCommitteeData(requester.byRequestOfId, 2);
                        break;
                    case "STANDING_COMMITTEE":
                        byRequestOfData = await fetchStandingCommitteeData(requester.byRequestOfId, 2);
                        break;
                    default:
                        byRequestOfData = null;
                        break;
                }
                return byRequestOfData;
            })
        );
        setBillDraftByRequestOfs(byRequestOfDataArray);
        return byRequestOfDataArray;
    }

    useEffect(() => {
        async function loadRequestorInfo() {
            try {
                const data = await fetchBillDraftByRequestOf(requestors);
                setBillDraftByRequestOfs(data);
                setLoading(false);
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        }

        loadRequestorInfo();
    }, [requestors]);

    if (loading) return <span>Loading...</span>;
    if (error) return <span>Error: {error.message}</span>;
    if (!billDraftByRequestOfs) return null;

    return billDraftByRequestOfs.map((requestOf, index) => (
        <span key={index}>
        {requestOf?.content?.[0]?.committeeDetails?.committeeCode?.name ||
            requestOf?.name ||
            (requestOf?.lastName && requestOf?.firstName
                ? `${requestOf.lastName}, ${requestOf.firstName}`
                : 'N/A')}
            {index < billDraftByRequestOfs.length - 1 ? '; ' : ''}
    </span>
    ));
}